(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ut-journal-article"] && !Shopify.designMode) return;
  try {
    
  class UtJournalArticle {
    constructor(root) {
      this.root = root;
      this.root.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const copyBtn = event.target.closest('[data-ut-copy]');
      if (copyBtn) {
        event.preventDefault();
        this.copyLink(copyBtn);
      }
    }

    copyLink(button) {
      const url = button.getAttribute('data-ut-copy');
      const toast = button.querySelector('.ut-share__toast');
      const show = () => {
        if (!toast) return;
        toast.hidden = false;
        setTimeout(() => { toast.hidden = true; }, 1600);
      };
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(show, show);
      } else {
        show();
      }
    }
  }

  for (const el of document.querySelectorAll('.ut-article')) {
    new UtJournalArticle(el);
  }

  } catch(e) { console.error(e); }
})();
})();
